import { atom } from 'recoil';

import { getFirebaseCustomMessage } from './queries';
import { FirebaseCustomMessage, MessageConfigGroup } from './types';

export const firebaseCustomMessages = atom({
  key: 'Firebase/CustomMessages',
  default: new Promise<FirebaseCustomMessage>((resolve) => {
    getFirebaseCustomMessage()
      .then((customMessages) => {
        const customMessagesGroup: MessageConfigGroup = {
          sendingChannelMessage: customMessages.sendingChannelMessage,
        };

        resolve({
          ...customMessagesGroup,
        });
      })
      .catch((_error) => {
        resolve({
          sendingChannelMessage: '',
        });
      });
  }),
});
